// Те же ограничения проверяет бэкенд; здесь они нужны, чтобы подсказать до отправки.
export const MAX_FILES = 5;
export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const FILE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'pdf', 'docx', 'txt', 'csv'];
export const FILES_ACCEPT = FILE_EXTENSIONS.map((extension) => `.${extension}`).join(',');
export const FILES_HINT = 'До 5 файлов, каждый до 10 МБ: изображения, PDF, DOCX, TXT, CSV';

export const MESSAGE_LIMIT = 4000;
